var $iQZGu$react = require("react");
var $iQZGu$reactjsxruntime = require("react/jsx-runtime");
var $iQZGu$styledcomponents = require("styled-components");
var $iQZGu$muimaterialCircularProgress = require("@mui/material/CircularProgress");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Loading", {
    enumerable: true,
    get: function get() {
        return $d961a07c81c03b9e$exports.Loading;
    }
});
var $d961a07c81c03b9e$exports = {};
"use strict";
function $d961a07c81c03b9e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d961a07c81c03b9e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d961a07c81c03b9e$var$_typeof(o);
}
Object.defineProperty($d961a07c81c03b9e$exports, "__esModule", {
    value: true
});
$d961a07c81c03b9e$exports.Loading = void 0;
var $c18ffb712a3662ff$exports = {};
"use strict";
Object.defineProperty($c18ffb712a3662ff$exports, "__esModule", {
    value: true
});
Object.defineProperty($c18ffb712a3662ff$exports, "LoadingIcon", {
    enumerable: true,
    get: function get() {
        return $1cd673be6fba9973$exports.LoadingIcon;
    }
});
var $1cd673be6fba9973$exports = {};
"use strict";
Object.defineProperty($1cd673be6fba9973$exports, "__esModule", {
    value: true
});
Object.defineProperty($1cd673be6fba9973$exports, "LoadingIcon", {
    enumerable: true,
    get: function get() {
        return $43bf6d4f3b2298a7$exports.LoadingIcon;
    }
});
var $43bf6d4f3b2298a7$exports = {};
"use strict";
Object.defineProperty($43bf6d4f3b2298a7$exports, "__esModule", {
    value: true
});
$43bf6d4f3b2298a7$exports.LoadingIcon = void 0;

var $43bf6d4f3b2298a7$var$_styledComponents = $43bf6d4f3b2298a7$var$_interopRequireDefault($iQZGu$styledcomponents);

var $43bf6d4f3b2298a7$var$_CircularProgress = $43bf6d4f3b2298a7$var$_interopRequireDefault($iQZGu$muimaterialCircularProgress);
var $43bf6d4f3b2298a7$var$_templateObject;
function $43bf6d4f3b2298a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $43bf6d4f3b2298a7$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $43bf6d4f3b2298a7$var$LoadingIcon = $43bf6d4f3b2298a7$exports.LoadingIcon = (0, $43bf6d4f3b2298a7$var$_styledComponents["default"])($43bf6d4f3b2298a7$var$_CircularProgress["default"])($43bf6d4f3b2298a7$var$_templateObject || ($43bf6d4f3b2298a7$var$_templateObject = $43bf6d4f3b2298a7$var$_taggedTemplateLiteral([
    "\n  &.MuiCircularProgress-colorPrimary {\n    color: ",
    ";\n  }\n"
])), function(props) {
    return props.theme.color.p500;
});







var $d961a07c81c03b9e$var$_react = $d961a07c81c03b9e$var$_interopRequireDefault($iQZGu$react);
var $ccc4a33aafa1a376$exports = {};
"use strict";
Object.defineProperty($ccc4a33aafa1a376$exports, "__esModule", {
    value: true
});
$ccc4a33aafa1a376$exports.LoadingWrapper = $ccc4a33aafa1a376$exports.LoadingMessage = void 0;

var $ccc4a33aafa1a376$var$_styledComponents = $ccc4a33aafa1a376$var$_interopRequireDefault($iQZGu$styledcomponents);
var $ccc4a33aafa1a376$var$_templateObject, $ccc4a33aafa1a376$var$_templateObject2;
function $ccc4a33aafa1a376$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $ccc4a33aafa1a376$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $ccc4a33aafa1a376$var$LoadingWrapper = $ccc4a33aafa1a376$exports.LoadingWrapper = $ccc4a33aafa1a376$var$_styledComponents["default"].div($ccc4a33aafa1a376$var$_templateObject || ($ccc4a33aafa1a376$var$_templateObject = $ccc4a33aafa1a376$var$_taggedTemplateLiteral([
    "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n"
])));
var $ccc4a33aafa1a376$var$LoadingMessage = $ccc4a33aafa1a376$exports.LoadingMessage = $ccc4a33aafa1a376$var$_styledComponents["default"].div($ccc4a33aafa1a376$var$_templateObject2 || ($ccc4a33aafa1a376$var$_templateObject2 = $ccc4a33aafa1a376$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n  color: ",
    ";\n\n  margin-left: 10px;\n"
])), function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.p500;
});



var $d961a07c81c03b9e$var$_excluded = [
    "size",
    "thickness",
    "className",
    "hideText",
    "loadingText"
];
function $d961a07c81c03b9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $d961a07c81c03b9e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d961a07c81c03b9e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d961a07c81c03b9e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d961a07c81c03b9e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d961a07c81c03b9e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d961a07c81c03b9e$var$_defineProperty(e, r, t) {
    return (r = $d961a07c81c03b9e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d961a07c81c03b9e$var$_toPropertyKey(t) {
    var i = $d961a07c81c03b9e$var$_toPrimitive(t, "string");
    return "symbol" == $d961a07c81c03b9e$var$_typeof(i) ? i : i + "";
}
function $d961a07c81c03b9e$var$_toPrimitive(t, r) {
    if ("object" != $d961a07c81c03b9e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d961a07c81c03b9e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d961a07c81c03b9e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d961a07c81c03b9e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $d961a07c81c03b9e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d961a07c81c03b9e$var$Loading = $d961a07c81c03b9e$exports.Loading = function Loading(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 30 : _ref$size, _ref$thickness = _ref.thickness, thickness = _ref$thickness === void 0 ? 7 : _ref$thickness, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$hideText = _ref.hideText, hideText = _ref$hideText === void 0 ? false : _ref$hideText, _ref$loadingText = _ref.loadingText, loadingText = _ref$loadingText === void 0 ? null : _ref$loadingText, rest = $d961a07c81c03b9e$var$_objectWithoutProperties(_ref, $d961a07c81c03b9e$var$_excluded);
    return /*#__PURE__*/ (0, $iQZGu$reactjsxruntime.jsxs)($ccc4a33aafa1a376$exports.LoadingWrapper, $d961a07c81c03b9e$var$_objectSpread($d961a07c81c03b9e$var$_objectSpread({}, rest), {}, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iQZGu$reactjsxruntime.jsx)($c18ffb712a3662ff$exports.LoadingIcon, {
                size: size,
                thickness: thickness
            }),
            !hideText && /*#__PURE__*/ (0, $iQZGu$reactjsxruntime.jsx)($ccc4a33aafa1a376$exports.LoadingMessage, {
                children: loadingText
            })
        ]
    }));
};




//# sourceMappingURL=index.js.map
